__turbopack_context__.v({
  "adminButton": "styles-module-scss-module__unqYtq__adminButton",
  "auctionIcon": "styles-module-scss-module__unqYtq__auctionIcon",
  "bounce": "styles-module-scss-module__unqYtq__bounce",
  "brand": "styles-module-scss-module__unqYtq__brand",
  "content": "styles-module-scss-module__unqYtq__content",
  "couponIcon": "styles-module-scss-module__unqYtq__couponIcon",
  "favoriteButton": "styles-module-scss-module__unqYtq__favoriteButton",
  "favoriteCount": "styles-module-scss-module__unqYtq__favoriteCount",
  "header": "styles-module-scss-module__unqYtq__header",
  "headerFavorite": "styles-module-scss-module__unqYtq__headerFavorite",
  "headerRight": "styles-module-scss-module__unqYtq__headerRight",
  "iconBadge": "styles-module-scss-module__unqYtq__iconBadge",
  "imageContainer": "styles-module-scss-module__unqYtq__imageContainer",
  "imageSearchButton": "styles-module-scss-module__unqYtq__imageSearchButton",
  "imageSearchText": "styles-module-scss-module__unqYtq__imageSearchText",
  "itemCard": "styles-module-scss-module__unqYtq__itemCard",
  "itemCardDropBadge": "styles-module-scss-module__unqYtq__itemCardDropBadge",
  "keyIcon": "styles-module-scss-module__unqYtq__keyIcon",
  "leftSection": "styles-module-scss-module__unqYtq__leftSection",
  "locationPrice": "styles-module-scss-module__unqYtq__locationPrice",
  "locationPriceReversed": "styles-module-scss-module__unqYtq__locationPriceReversed",
  "long": "styles-module-scss-module__unqYtq__long",
  "mobileCarouselTag": "styles-module-scss-module__unqYtq__mobileCarouselTag",
  "mobileCarouselTags": "styles-module-scss-module__unqYtq__mobileCarouselTags",
  "price": "styles-module-scss-module__unqYtq__price",
  "priceColumn": "styles-module-scss-module__unqYtq__priceColumn",
  "priceInsight": "styles-module-scss-module__unqYtq__priceInsight",
  "priceInsightSpacer": "styles-module-scss-module__unqYtq__priceInsightSpacer",
  "priceStack": "styles-module-scss-module__unqYtq__priceStack",
  "priceValue": "styles-module-scss-module__unqYtq__priceValue",
  "proAdCard": "styles-module-scss-module__unqYtq__proAdCard",
  "rentableBadge": "styles-module-scss-module__unqYtq__rentableBadge",
  "shareLink": "styles-module-scss-module__unqYtq__shareLink",
  "size": "styles-module-scss-module__unqYtq__size",
  "sizeDisplay": "styles-module-scss-module__unqYtq__sizeDisplay",
  "sizeVendorColumn": "styles-module-scss-module__unqYtq__sizeVendorColumn",
  "sold": "styles-module-scss-module__unqYtq__sold",
  "soldLabel": "styles-module-scss-module__unqYtq__soldLabel",
  "timeAgo": "styles-module-scss-module__unqYtq__timeAgo",
  "title": "styles-module-scss-module__unqYtq__title",
  "topRightIcons": "styles-module-scss-module__unqYtq__topRightIcons",
  "vendor": "styles-module-scss-module__unqYtq__vendor",
  "vendorRow": "styles-module-scss-module__unqYtq__vendorRow",
  "warningIcon": "styles-module-scss-module__unqYtq__warningIcon",
});
